import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SliderControl } from '../../components/controls/NewSliderControl';
import { backOnboarding, completeOnboarding, pathAware } from '../../actions/onboardingActions';
import { currencyFormatter } from '../../components/Money';

export const STEP_SIZE = 100;

class MonthlySavings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthlySavings: props.qna_hash.monthlySavings
        ? props.qna_hash.monthlySavings.answer
        : `${this.calcDefaultAmount(props)}`,
    };
  }

  calcDefaultAmount = props => {
    if (!props.primaryBase) {
      return 500;
    }
    let incomeYearly = parseInt(props.qna_hash.primaryBase.answer);
    if (props.qna_hash.hasPartner.answer) {
      incomeYearly += parseInt(props.qna_hash.partnerBase.answer);
    }

    return Math.round(incomeYearly * 0.05 / 12 / STEP_SIZE) * STEP_SIZE;
  };

  componentDidMount() {
    this.props.pathAware('monthlySavings');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.monthlySavings) {
      this.setState({
        monthlySavings: props.qna_hash.monthlySavings.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .completeOnboarding(qna_stack, qna_hash, {
        monthlySavings: {
          question: 'What will your living expenses be in retirement?',
          answer: this.state.monthlySavings,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = evt => {
    this.setState({ monthlySavings: evt.detail.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { monthlySavings } = this.state;

    if (!qna_hash.primaryBase) {
      return <LoadingBar />;
    }

    let incomeYearly = parseInt(qna_hash.primaryBase.answer);
    if (qna_hash.hasPartner.answer) {
      incomeYearly += parseInt(qna_hash.partnerBase.answer);
    }

    // round max monthly expenses in dollars to the nearest $`STEP_SIZE`, currently $100
    const maxSavingsMonthly = Math.round(incomeYearly * 0.3 / 12 / STEP_SIZE) * STEP_SIZE;
    const minSavingsMonthly = 0;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What are you currently saving each month?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text use="body1" className="ml-4 mr-4">
            Enter the total amount you {qna_hash.hasPartner.answer ? 'and your spouse ' : ''}set aside each month across
            all your accounts.
          </Text>
        </div>

        <div style={{ width: '80%' }}>
          <Typography
            use="subtitle1"
            tag="div"
            style={{ marginTop: '0.75rem', marginBottom: '-0.25rem', textAlign: 'center' }}
          >
            Currently Saving: <span style={{ fontWeight: 500 }}>{currencyFormatter(monthlySavings)}/month</span>
          </Typography>
          <SliderControl
            id="monthlySavings"
            spec={{
              field_type: 'range',
              min: minSavingsMonthly,
              max: maxSavingsMonthly,
              step_size: STEP_SIZE,
              _default: 500,
            }}
            onChange={this.onChange}
            onInput={this.onChange}
            value={monthlySavings}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text use="subtitle1">{currencyFormatter(minSavingsMonthly)}/month</Text>
            <Text use="subtitle1">{currencyFormatter(maxSavingsMonthly)}/month</Text>
          </div>
        </div>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, completeOnboarding, pathAware })(MonthlySavings);
